var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgService = function SvgService(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path847",
    fill: "currentColor",
    d: "M2.257 19.184c-.523-.566-.75-1.086-.75-1.719 0-.806.53-1.485 4.753-6.073l4.754-5.165-.16-1.267C10.55 2.577 12.103.534 14.53.12c1.997-.341 2.127.002.626 1.645L13.82 3.228l.3 1.403c.297 1.39.312 1.406 1.597 1.727l1.297.324 1.354-1.446c1.52-1.622 1.838-1.481 1.521.678-.38 2.588-2.305 4.298-4.476 3.976l-1.172-.174-4.778 5.14c-4.243 4.565-4.871 5.14-5.616 5.14-.585 0-1.067-.246-1.59-.812zm2.203-1.687c0-.51-.155-.718-.58-.783-.347-.054-.64.085-.733.347-.256.72.103 1.316.734 1.219.424-.065.579-.274.579-.783m9.146.146-2.212-2.353 2.847-3.087 2.108 2.335c2.38 2.637 2.65 3.508 1.478 4.776-1.11 1.2-1.769.938-4.221-1.671M5.232 7.223c-.833-.913-1.68-1.532-2.5-1.827-1.116-.4-1.318-.608-1.987-2.041L0 1.759 1.59.04 3.06.843c1.312.716 1.517.948 1.89 2.13.264.839.891 1.845 1.701 2.732L7.935 7.11 6.491 8.606z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgService);
export default ForwardRef;